// couponUserService.js
// Serviço frontend para o fluxo de CouponUser (vínculos coupon_users).
// Espelha o padrão de couponService.js.

import api from "./api";

function hasFilterValue(value) {
  return value !== null && value !== undefined && value !== "";
}

/**
 * Busca vínculos coupon_users de forma paginada com filtros opcionais.
 *
 * @param {number} pageNumber
 * @param {number} pageSize
 * @param {object} filters
 *   - couponId    {string}         – substring numérica sobre coupon_id
 *   - userId      {string}         – igualdade exata sobre user_id
 *   - couponCode  {string}         – substring textual (LIKE) em coupons.code
 *   - userName    {string}         – substring textual (LIKE) em users.user_name
 *   - isRevoked   {boolean|string} – true | false | "" (todos)
 *   - isRedeemed  {boolean|string} – true | false | "" (todos)
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function fetchCouponUsersPaged(pageNumber, pageSize, filters = {}) {
  const params = { pageNumber, pageSize };

  if (filters.couponId?.trim()) {
    params.couponId = filters.couponId.trim();
  }
  if (filters.userId?.trim()) {
    params.userId = filters.userId.trim();
  }
  if (filters.couponCode?.trim()) {
    params.couponCode = filters.couponCode.trim();
  }
  if (filters.userName?.trim()) {
    params.userName = filters.userName.trim();
  }

  // ✅ Booleans: preserva `false` como filtro válido (só ignora "" e null/undefined)
  if (hasFilterValue(filters.isRevoked)) {
    params.isRevoked = filters.isRevoked;
  }
  if (hasFilterValue(filters.isRedeemed)) {
    params.isRedeemed = filters.isRedeemed;
  }

  return api.get("/CouponUsers/paged", { params });
}

/**
 * Busca um vínculo coupon_user pelo seu ID.
 * @param {number} id
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function getCouponUserById(id) {
  return api.get(`/CouponUsers/${id}`);
}

/**
 * Cria um novo vínculo coupon_user (somente Sys).
 *
 * ⚠️ O backend rejeita com 400 se o cupom não for TARGETED.
 *
 * @param {object} data - { couponId, userId }
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function createCouponUser(data) {
  return api.post("/CouponUsers", data);
}

/**
 * Atualiza um vínculo coupon_user existente (revogar/desrevogar/ajustar RedeemedAt).
 * @param {object} data - { couponUserId, revokedAt, redeemedAt }
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function updateCouponUser(data) {
  return api.put(`/CouponUsers/${data.couponUserId}`, data);
}

/**
 * Exclui um vínculo coupon_user pelo seu ID.
 * @param {number} id
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function deleteCouponUser(id) {
  return api.delete(`/CouponUsers/${id}`);
}

/**
 * Exclui múltiplos vínculos coupon_users em lote.
 * Backend: DELETE /api/CouponUsers/batch
 *
 * @param {number[]} ids
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function deleteCouponUsersBatch(ids) {
  return api.delete("/CouponUsers/batch", { data: ids });
}
